<div class="uni-price-box__currency">
  {{ currency }}
</div>
<div class="uni-price-box__value">
  <ng-content></ng-content>
</div>
